import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { groupDocs } from '../content/docsUtils';
import { docPages } from '../content/docs.generated';
import '../marketing/Marketing.css';

function HelpDocsIndex() {
  const groups = groupDocs(docPages);

  useEffect(() => {
    document.title = 'Help — Racontera';
  }, []);

  return (
    <div className="docs-index docs-index-app">
      <h1>Help &amp; documentation</h1>
      <p className="docs-index-intro">
        Product guides and internal notes. Public pages are also available at{' '}
        <Link to="/docs">/docs</Link>.
      </p>
      {groups.length === 0 ? (
        <p>No documentation published yet.</p>
      ) : (
        groups.map((group) => (
          <section key={group.id} className="docs-group">
            <h2 className="docs-group-title">{group.label}</h2>
            <ul className="docs-list">
              {group.pages.map((page) => (
                <li key={page.slug} className="docs-list-item">
                  <Link to={`/help/${page.slug}`} className="docs-list-link">
                    <span className="docs-list-title">
                      {page.title}
                      {page.access === 'auth' && (
                        <span className="docs-badge docs-badge-auth">Team</span>
                      )}
                    </span>
                    {page.excerpt && (
                      <span className="docs-list-excerpt">{page.excerpt}</span>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))
      )}
    </div>
  );
}

export default HelpDocsIndex;
